

<form>
  <div mat-dialog-title>
      <a mat-icon-button (click)="onCloseDialog()" cdkFocusInitial>
         <!-- <mat-icon >keyboard_backspace</mat-icon> -->
         <!-- <i class='fas fa-arrow-left fa-lg'></i> -->
         <img [src]=backimg class="iconimage"/>
      </a>
      <label class="title"> Work In Progress</label>
  </div>
<mat-dialog-content>
      <div class="mainBox">
          <div class="group">
              <div class="txtbox"> Start&nbsp;&nbsp;&nbsp; <input type="text"  [(ngModel)]="Jobstarttime" name="Jobstarttime" /> </div>
              <div class="txtbox"> Pause&nbsp; <input type="text" [(ngModel)]="pausTime" name="pausTime" /> &nbsp;
                  <a href="" onclick="return false;"  id="details" [mdePopoverTriggerFor]="appPopover"
                   mdePopoverTriggerOn="click" #popoverTrigger="mdePopoverTrigger" (click)="h1()"><i>Details</i></a>
              </div>
              <div class="txtbox" > Finish &nbsp; <input type="text" /></div>
          </div>
      </div>
      <mde-popover #appPopover="mdePopover" [mdePopoverOverlapTrigger]="false">
          <mat-card >
            <mat-card-content>
              <table class="table table-striped" *ngIf="timePopover">
                  <thead>
                    <tr>
                      <th scope="col">Start time</th>
                      <th scope="col">End time</th>
                    </tr>
                  </thead>
                  <ng-container *ngIf="showTimeArray.length">
                     <tbody >
                       <tr *ngFor="let item of showTimeArray">
                         <td>{{item.starttime2}}</td>
                         <td>{{item.endtime2}}</td>
                       </tr>
                     </tbody>
                   </ng-container>
              </table>
            </mat-card-content>
          </mat-card>
        </mde-popover>

      <div class="MainCircleDiv">
          <div class="circularDiv">
              <div id=circle *ngIf="showPauseButton">
                  <h1><b>{{h}}:{{m}}:{{s}}</b></h1>
              </div>
              <div id=circle *ngIf="!showPauseButton" >
                  <h1><b>{{pausTime}}</b></h1>
              </div>
          </div>
       </div>
</mat-dialog-content>

<mat-dialog-actions class="" align="center">
      <!-- <a mat-icon-button cdkFocusInitial (click)="resumeTimer()">
          <mat-icon >play_circle_filled</mat-icon>
      </a> &nbsp; &nbsp; &nbsp; &nbsp;

      <a mat-icon-button cdkFocusInitial (click)="pauseTimer()">
          <mat-icon >pause_circle_filled</mat-icon>
      </a> &nbsp; &nbsp; &nbsp; &nbsp;

      <a mat-icon-button cdkFocusInitial (click)="stopTimer()">
          <mat-icon >stop</mat-icon>
      </a> -->
      <button mat-mini-fab color="warn" class="playactionbutton" *ngIf="!showPauseButton" aria-label="Example icon button with a menu icon"  (click)="resumeTimer()">
          <!-- <mat-icon>play_arrow</mat-icon> -->
          <!-- <i class='fas fa-play'></i> -->
          <img [src]=playimg class="iconimage"/>
        </button>
        <button mat-mini-fab color="warn" *ngIf="showPauseButton" class="playactionbutton" aria-label="Example icon button with a menu icon" (click)="pauseTimer()">
          <!-- <mat-icon>pause</mat-icon> -->
          <!-- <i class='fas fa-pause'></i> -->
          <img [src]=pauseimg class="iconimage"/>
        </button>

      
      
        <button mat-mini-fab color="warn"  aria-label="Example icon button with a menu icon" [mdePopoverTriggerFor]="Popover"
      mdePopoverTriggerOn="click" (click)="stopButtonClick()">
          <!-- <mat-icon >stop</mat-icon> -->
          <!-- <i class='fas fa-stop'></i> -->
          <img [src]=stopimg class="iconimage"/>
        </button>
        
        <mde-popover #Popover="mdePopover" >
          <div *ngIf="!disableFinish && !disable && !disableSub && !disableothertyre && !disableoilsupplier" >
          <mat-card>
            <div align="right">
              <!-- <mat-icon  cdkFocusInitial>close</mat-icon></div> -->
              <button mat-icon-button  class="icon-button-small" >
                <!-- <mat-icon>close</mat-icon> -->
                <!-- <i class='fas fa-times'></i> -->
                <img [src]=closeimg class="iconimage"/>
            </button></div>
            
            <mat-card-content>
              Are you sure to finish the Job?
              <p *ngIf="isPM">This will update Wizard and Respex and can not be undone</p>
            </mat-card-content>
            <div align="right">
              <button mat-raised-button >Return</button> &nbsp;
              <button mat-raised-button (click)="stopTimer()" [disabled]="disableFinish" >Finish</button> &nbsp;
                
            </div>
          
          </mat-card>
        
        </div>
       
        </mde-popover>
     
      

</mat-dialog-actions>
</form>